var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2993685_brand_brands_google_logo_logos_icon 1",
    clipPath: "url(#clip0_0_18362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.00021 2.91667C7.94332 2.91667 8.80927 3.23956 9.50056 3.77653L11.6222 1.75239C10.3887 0.664973 8.77392 0 7.00021 0C4.31244 0 1.9816 1.51662 0.808594 3.73908L3.16785 5.60162C3.73936 4.0363 5.23707 2.91667 7.00021 2.91667Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.9394 7.87591C13.9758 7.58912 14 7.29656 14 6.99984C14 6.49943 13.9453 6.01215 13.8456 5.5415H7V8.45817H10.7836C10.4775 9.2537 9.93255 9.92686 9.23884 10.3945L11.6069 12.264C12.8621 11.1622 13.7212 9.61921 13.9394 7.87591Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.91667 7.00018C2.91667 6.50817 3.00817 6.03863 3.16764 5.6018L0.808385 3.73926C0.294195 4.71352 0 5.82194 0 7.00018C0 8.16524 0.288783 9.26138 0.792292 10.2277L3.15454 8.36281C3.00326 7.9361 2.91667 7.47876 2.91667 7.00018Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.9997 11.0835C5.22314 11.0835 3.71578 9.94688 3.15424 8.36279L0.791992 10.2277C1.95926 12.468 4.29876 14.0002 6.9997 14.0002C8.7659 14.0002 10.3765 13.344 11.6066 12.2643L9.23854 10.3948C8.59874 10.8262 7.83294 11.0835 6.9997 11.0835Z",
    fill: "#00B060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.1,
    d: "M6.99961 13.8541C4.93946 13.8541 3.08703 13.0041 1.77734 11.6499C3.0594 13.0887 4.92088 14 6.99961 14C9.05911 14 10.9052 13.1067 12.1843 11.6904C10.8785 13.0227 9.04017 13.8541 6.99961 13.8541Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.1,
    d: "M7 8.3125V8.45833H10.7836L10.8427 8.3125H7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.9971 7.08553C13.9975 7.0568 13.9999 7.02856 13.9999 6.99976C13.9999 6.99161 13.9988 6.98374 13.9988 6.97559C13.9984 7.01233 13.9968 7.04865 13.9971 7.08553Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.2,
    d: "M7 5.5415V5.68734H13.8749C13.8657 5.6392 13.8557 5.58928 13.8456 5.5415H7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M13.8456 5.54167H7V8.45833H10.7836C10.1952 9.98759 8.73668 11.0833 7 11.0833C4.74485 11.0833 2.91667 9.25515 2.91667 7C2.91667 4.74482 4.74485 2.91667 7 2.91667C7.81775 2.91667 8.57145 3.16789 9.20997 3.58207C9.3077 3.64558 9.40853 3.70522 9.50035 3.77653L11.622 1.75239L11.5742 1.71557C10.3465 0.651621 8.75206 0 7 0C3.13399 0 0 3.13399 0 7C0 10.866 3.13399 14 7 14C10.5686 14 13.5073 11.3276 13.9394 7.87607C13.9758 7.58928 14 7.29672 14 7C14 6.49959 13.9453 6.01231 13.8456 5.54167Z",
    fill: "url(#paint0_linear_0_18362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.1,
    d: "M9.21029 3.43629C8.57177 3.02211 7.81807 2.77089 7.00033 2.77089C4.74518 2.77089 2.91699 4.59904 2.91699 6.85422C2.91699 6.87883 2.91732 6.89805 2.91775 6.92258C2.95709 4.70144 4.76978 2.91672 7.00033 2.91672C7.81807 2.91672 8.57177 3.16794 9.21029 3.58212C9.30802 3.64564 9.40885 3.70528 9.50068 3.77659L11.6223 1.75244L9.50068 3.63076C9.40885 3.55944 9.30802 3.49981 9.21029 3.43629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.2,
    d: "M7 0.145833C8.73544 0.145833 10.315 0.78656 11.5379 1.8326L11.622 1.75239L11.5578 1.69649C10.3302 0.632543 8.75207 0 7 0C3.13399 0 0 3.13399 0 7C0 7.0246 0.00341798 7.04835 0.00366718 7.07292C0.0431874 3.24091 3.1586 0.145833 7 0.145833Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_18362",
    x1: 0,
    y1: 7,
    x2: 14,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_18362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.a28731d71ed23a69a710b0475bdb50b1.svg";
export { ForwardRef as ReactComponent };